import './applianceDocuments.scss';

import React, { useState } from 'react';

import FsLightbox from 'fslightbox-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { GetDocDisplayName } from '../../utils';
import { IImage } from '../../interfaces';
import downloadIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Download-icon.svg';
import downloadIconBlack from '@progymedia/sbi-web-englander/src/images/englander-icons/Download-Icon-Black.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function ApplianceDocuments(props: {
    documents: any;
    code: string;
    vuesIPEP: any;
    displayIPEP?: boolean;
    scrollManuals?: boolean;
}) {
    const {
        documents,
        code,
        vuesIPEP,
        displayIPEP = true,
        scrollManuals = true,
    } = props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('layout');

    const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);

    const getVuesIPEPImageSrc = () => {
        return vuesIPEP.map((vueIPEP: IImage) => vueIPEP?.childImageSharp
            ?.gatsbyImageData?.images
            ?.fallback?.src);
    }

    return (
        <div className='appliance-manual-docs'>
            {vuesIPEP?.length > 0 && displayIPEP && (
                <div className='appliance-schemas'>
                    <span>{t('appliance.technical-views')}</span>
                    <div className='vues-ipep'>
                        {vuesIPEP?.map((vueIPEP: IImage, key: number) => {
                            return (
                                <div
                                    key={key}
                                    className='vue-ipep'
                                    onClick={() => setIsLightBoxVisible(!isLightBoxVisible)}
                                >
                                    <GatsbyImage
                                        image={
                                            vueIPEP?.childImageSharp
                                                ?.gatsbyImageData
                                        }
                                        alt=''
                                    />
                                </div>
                            );
                        })}
                        <FsLightbox
                            toggler={isLightBoxVisible}
                            exitFullscreenOnClose={true}
                            sources={getVuesIPEPImageSrc()}
                        />
                    </div>
                </div>
            )}
            <div
                className='appliance-documents'
                style={{
                    overflowY: scrollManuals ? 'auto' : 'hidden',
                    maxHeight: scrollManuals ? '700px' : 'initial',
                }}
            >
                {documents?.map((document: any, index: number) => {
                    if (document?.[currentLocale] === 'null') return;

                    const [bytes, setBytes] = useState<string | null>('0');
                    const [isHovering, setIsHovering] = useState(false);
                    const url = '/file/' + document?.[currentLocale];

                    if (typeof window !== 'undefined') {
                        const request = new XMLHttpRequest();
                        request.onreadystatechange = function () {
                            if (this.readyState == 2) {
                                setBytes(
                                    request?.getResponseHeader('content-length')
                                );
                            }
                        };
                        request.open('HEAD', url);
                        request.send();
                    }
                    return (
                        <div
                            className='document-info-manual-container'
                            key={index}
                        >
                            <div className='document-info'>
                                <a
                                    rel='noreferrer'
                                    target='_blank'
                                    href={url}
                                    className='document-download'
                                    onMouseEnter={() => setIsHovering(true)}
                                    onMouseLeave={() => setIsHovering(false)}
                                >
                                    {GetDocDisplayName(document, code)}
                                    <img
                                        src={
                                            isHovering
                                                ? downloadIconBlack
                                                : downloadIcon
                                        }
                                        alt=''
                                    ></img>
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
